import { render, staticRenderFns } from "./ConferenceRoomKiosk.vue?vue&type=template&id=012046aa&scoped=true&"
import script from "./ConferenceRoomKiosk.vue?vue&type=script&lang=js&"
export * from "./ConferenceRoomKiosk.vue?vue&type=script&lang=js&"
import style0 from "./ConferenceRoomKiosk.vue?vue&type=style&index=0&id=012046aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "012046aa",
  null
  
)

export default component.exports